import {
  ClubBean,
  ClubPropertiesDTOWithRawPhoneNumberCountry,
  ClubPropertiesSettings,
  ClubSettings,
  FeatureFlags,
} from "@gymflow/types";

import { createPublicAxiosInstance } from "./publicAxiosInstance";

export type PublicClubApiType = ReturnType<typeof publicClubApi>;

const publicClubApi = (apiUrl: string, clubId: number) => {
  const axiosInstance = createPublicAxiosInstance({ apiUrl });
  const clubPrefix = `club/${clubId}/`;

  return {
    findById(id: number) {
      return axiosInstance.get<ClubBean>(`club/${id}/hosted`);
    },
    settings() {
      return axiosInstance.get<{ settings: ClubSettings }>(
        `${clubPrefix}hosted/settings`,
      );
    },
    properties() {
      return axiosInstance.get<ClubPropertiesDTOWithRawPhoneNumberCountry>(
        `${clubPrefix}hosted/properties`,
      );
    },
    propertiesSettings() {
      return axiosInstance.get<ClubPropertiesSettings>(`${clubPrefix}hosted/properties-settings`);
    },
    featureFlags() {
      return axiosInstance.get<FeatureFlags>(`${clubPrefix}hosted/feature-flags`);
    },
  };
};

export default publicClubApi;
